import UserTag from "../../components/UserTag";
import {
  BaseFilterOptions,
  BaseFilters,
  FilterOption,
  OrganizationSecret,
  OrganizationVariable,
} from "../../models/types";
import { IColumnVisibility } from "../../molecules/ColumnVisibility";
import { OrganizationSecretDisplay } from "../../molecules/OrganizationSecretDisplay";
import { TableTextWithEllipsis } from "../../molecules/TableTextWithEllipsis";
import { defaultDateDisplay } from "../UIHelper";

export const organizationListFilterOptions: FilterOption<BaseFilters>[] = [
  { label: "Name", value: "name" },
  ...BaseFilterOptions,
];

export const organizationVariablesListColumnsVisibility: IColumnVisibility<OrganizationVariable>[] =
  [
    {
      field: "name",
      headerName: "Name",
      visible: true,
      columnMinWidth: 400,
      renderer: (orgVar) => <TableTextWithEllipsis value={orgVar.name} />,
    },
    {
      field: "value",
      headerName: "Value",
      visible: true,
      renderer: (orgVar) => <TableTextWithEllipsis value={orgVar.value} />,
    },
    {
      field: "updated_by",
      headerName: "Updated On",
      visible: true,
      renderer: (orgVar) => {
        return defaultDateDisplay(orgVar.updated_on);
      },
    },
    {
      field: "updated_by",
      headerName: "Updated By",
      visible: true,
      renderer: (orgVar) => {
        return <UserTag name={orgVar.updated_by.name} />;
      },
    },
  ];

export const organizationSecretsListColumnsVisibility: IColumnVisibility<OrganizationSecret>[] = [
  {
    field: "name",
    headerName: "Name",
    visible: true,
    columnMinWidth: 400,
    renderer: (orgVar) => <OrganizationSecretDisplay value={orgVar} />,
  },
  {
    field: "updated_by",
    headerName: "Updated On",
    visible: true,
    renderer: (orgVar) => {
      return defaultDateDisplay(orgVar.updated_on);
    },
  },
  {
    field: "updated_by",
    headerName: "Updated By",
    visible: true,
    renderer: (orgVar) => {
      return <UserTag name={orgVar.updated_by.name} />;
    },
  },
];
